import GoogleMapReact from 'google-map-react'
import { LONDON_LOCATION } from '../constants'
import { Location } from '../interfaces'
import { Collection, LocationMarker, Truck } from './icons'

interface Markers {
    collection?: Location
    delivery?: Location
    courier?: Location
}

interface JobMapProps {
    markers: Markers
}

export const JobMap = ({ markers }: JobMapProps) => {
    const { collection, delivery, courier } = markers

    const defaultMapCenter =
        courier && Object.keys(courier).length
            ? { lat: courier.latitude, lng: courier.longitude }
            : delivery && Object.keys(delivery).length
            ? { lat: delivery.latitude, lng: delivery.longitude }
            : LONDON_LOCATION

    const bindResizeListener = (
        map: google.maps.Map,
        maps: any,
        bounds: google.maps.LatLngBounds,
    ) => {
        maps.event.addDomListenerOnce(map, 'idle', () => {
            maps.event.addDomListener(window, 'resize', () => {
                map.fitBounds(bounds)
            })
        })
    }

    const onGoogleApiLoaded = (
        map: google.maps.Map,
        maps: any,
        markers: Markers,
    ) => {
        const bounds = new maps.LatLngBounds()
        Object.values(markers).forEach((marker) => {
            if (marker && Object.keys(marker).length) {
                bounds.extend(
                    new maps.LatLng(marker.latitude, marker.longitude),
                )
            }
        })
        map.fitBounds(bounds)
        bindResizeListener(map, maps, bounds)
    }

    return (
        <div className="w-full h-96">
            {Object.values(markers).filter((m) => m).length > 0 && (
                <GoogleMapReact
                    bootstrapURLKeys={{
                        key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
                    }}
                    defaultZoom={12}
                    defaultCenter={defaultMapCenter}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map, maps }) =>
                        onGoogleApiLoaded(map, maps, markers)
                    }>
                    {collection && Object.keys(collection).length && (
                        <Collection
                            lat={collection.latitude}
                            lng={collection.longitude}
                        />
                    )}
                    {delivery && Object.keys(delivery).length && (
                        <LocationMarker
                            lat={delivery.latitude}
                            lng={delivery.longitude}
                        />
                    )}
                    {courier && Object.keys(courier).length && (
                        <Truck lat={courier.latitude} lng={courier.longitude} />
                    )}
                </GoogleMapReact>
            )}
        </div>
    )
}
